import AboutPage from "../Components/About/AboutPage.tsx";

const About = () => {
  return (
    <>
      <AboutPage />
    </>
  );
};

export default About;
